// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/common/http.proto (package infinigence.infini.agentplatform.common, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/common/http.proto.
 */
export const file_agentplatform_common_http: GenFile = /*@__PURE__*/
  fileDesc("Ch9hZ2VudHBsYXRmb3JtL2NvbW1vbi9odHRwLnByb3RvEidpbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5jb21tb24iHQoKR2V0UmVxdWVzdBIPCgJpZBgBIAEoCUID4EECItYECgtMaXN0UmVxdWVzdBIMCgRwYWdlGAEgASgFEhEKCXBhZ2Vfc2l6ZRgCIAEoBRJQCgZmaWx0ZXIYAyADKAsyQC5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5jb21tb24uTGlzdFJlcXVlc3QuRmlsdGVyRW50cnkSTgoFZnV6enkYBCADKAsyPy5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5jb21tb24uTGlzdFJlcXVlc3QuRnV6enlFbnRyeRIQCghvcmRlcl9ieRgFIAMoCRJICgJpbhgGIAMoCzI8LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLmNvbW1vbi5MaXN0UmVxdWVzdC5JbkVudHJ5Ek8KBm5vdF9pbhgHIAMoCzI/LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLmNvbW1vbi5MaXN0UmVxdWVzdC5Ob3RJbkVudHJ5Eg8KB2lzX251bGwYCCADKAkSEAoIbm90X251bGwYCSADKAkaLQoLRmlsdGVyRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ARosCgpGdXp6eUVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEaKQoHSW5FbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBGiwKCk5vdEluRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AUJRWk9naXRsYWIuaW5maW5pLWFpLmNvbS9taXphci9pbmZpbmlhaS1hZ2VudGljLWluZnJhL2NvbW1vbi9ncnBjYXBpcy9jb21tb247Y29tbW9uYgZwcm90bzM", [file_google_api_field_behavior]);

/**
 * @generated from message infinigence.infini.agentplatform.common.GetRequest
 */
export type GetRequest = Message<"infinigence.infini.agentplatform.common.GetRequest"> & {
  /**
   * 资源ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.common.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_common_http, 0);

/**
 * @generated from message infinigence.infini.agentplatform.common.ListRequest
 */
export type ListRequest = Message<"infinigence.infini.agentplatform.common.ListRequest"> & {
  /**
   * 分页的当前页码
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * 每页大小
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * 精确过滤, like ?filter.name=alice&filter.status=active
   *
   * @generated from field: map<string, string> filter = 3;
   */
  filter: { [key: string]: string };

  /**
   * 模糊搜索, like ?fuzzy.name=demo
   *
   * @generated from field: map<string, string> fuzzy = 4;
   */
  fuzzy: { [key: string]: string };

  /**
   * 排序, like ?order_by=created_at-&order_by=name+
   *
   * @generated from field: repeated string order_by = 5;
   */
  orderBy: string[];

  /**
   * IN 过滤, like ?in.tenant_id=t1|t2
   *
   * @generated from field: map<string, string> in = 6;
   */
  in: { [key: string]: string };

  /**
   * NOT IN 过滤, like ?not_in.tenant_id=t1|t2
   *
   * @generated from field: map<string, string> not_in = 7;
   */
  notIn: { [key: string]: string };

  /**
   * IS NULL 过滤, like ?is_null=deleted_at
   *
   * @generated from field: repeated string is_null = 8;
   */
  isNull: string[];

  /**
   * IS NOT NULL 过滤, like ?not_null=updated_at
   *
   * @generated from field: repeated string not_null = 9;
   */
  notNull: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.common.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_common_http, 1);

